import React from "react";

const ErrorIcon = ({
    height = 14,
    width = 14,
    svgFill="none",
    pathFill="#E03923"
  }: {
    height?: number;
    width?: number;
    svgFill?:string;
    pathFill?:string;
  }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill={svgFill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.4572 7.00018C13.4572 10.5664 10.5662 13.4574 6.99999 13.4574C3.43378 13.4574 0.542786 10.5664 0.542786 7.00018C0.542786 3.43396 3.43378 0.542969 6.99999 0.542969C10.5662 0.542969 13.4572 3.43396 13.4572 7.00018ZM6.99999 10.6331C7.41421 10.6331 7.74999 10.2973 7.74999 9.88306C7.74999 9.46885 7.41421 9.13306 6.99999 9.13306H6.99279C6.57857 9.13306 6.24279 9.46885 6.24279 9.88306C6.24279 10.2973 6.57857 10.6331 6.99279 10.6331H6.99999ZM6.24999 7.00018C6.24999 7.41439 6.58578 7.75018 6.99999 7.75018C7.41421 7.75018 7.74999 7.41439 7.74999 7.00018V4.11729C7.74999 3.70308 7.41421 3.36729 6.99999 3.36729C6.58578 3.36729 6.24999 3.70308 6.24999 4.11729V7.00018Z"
        fill={pathFill}
      />
    </svg>
  );
};

export default ErrorIcon;
